var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-jumbotron',{attrs:{"header-level":"4"},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v(_vm._s(_vm.course.name))]},proxy:true}])},[_c('hr',{staticClass:"my-4"}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.course.description)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }